import React from "react";
import Homepage from "./Homepage";

export const Home = () => {
  return (
    <div>
      <Homepage />
      
    </div>
  );
};
